/* globals AUTH */
/*
Extension of the Backbone Model to work better with Django-Tastypie

Based on http://paltman.com/2012/04/30/integration-backbonejs-tastypie/
*/
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';


export default Backbone.Model.extend({
  base_url: function () {
    var temp_url = Backbone.Model.prototype.url.call(this);
    return temp_url.charAt(temp_url.length - 1) === '/' ? temp_url : temp_url + '/';
  },

  get: function (attr) {
    // This method allows child models to create a 'attrname' function
    // to return transformations of an 'attrname' attribute. When
    // you call `.get('attrname')` the results of executing the
    // function will be return. NOTE: It doesn't work with attributes
    // that have the same name as built-in Backbone.Model functions,
    // such as `trigger`
    if (typeof this[attr] === 'function') {
      if (typeof Backbone.Model.prototype[attr] === 'undefined') {
        return this[attr]();
      }
    }

    return Backbone.Model.prototype.get.call(this, attr);
  },

  params: {},

  base_params: function () {
    return mobile ? _.extend({
      username: window.localStorage.getItem('USERNAME'),
      api_key: window.localStorage.getItem('API_KEY')
    }, AUTH) : {};
  },

  url: function () {
    var result = this.base_url();
    this.params = _.extend(this.base_params(), this.params);
    if (!_.isEmpty(this.params)) {
      result = result + ('?' + $.param(this.params));
    }
    return result;
  },

  parse: function (data) {
    // Return the first entry in 'data.objects' if it exists and is an array, or else just plain 'data'.
    // from https://github.com/PaulUithol/backbone-tastypie/blob/master/backbone_tastypie/static/js/backbone-tastypie.js
    return data && data.objects && (_.isArray(data.objects) ? data.objects[0] : data.objects) || data;
  },

  flatten_rec: function (val, key, context) {
    // Flattens nested model attribute objects for event tracking. Ex.
    // {id: 1, target_behavior: {id: 2, name: 'test'}}
    // becomes
    // {id: 1, target_behavior_id: 2, target_behavior_name: 'test'}
    var data = {};
    if (typeof val === 'object') {
      _.each(val, function (v, k) {
        var new_key = key ? key + '_' + k : k;
        _.extend(data, context.flatten_rec(v, new_key, context));
      });
    } else {
      data[key] = val;
    }
    return data;
  },

  track_data: function () {
    return this.flatten_rec(this.attributes, null, this);
  },

  toJSON: function (options) {
    return _.mapObject(
      Backbone.Model.prototype.toJSON.call(this, options),
      function (val, key) {
        return this.get(key);
      },
      this
    );
  }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/orcas-core/core/static/js/core/models/core.js
// module id = 4
// module chunks = 0